export default __webpack_public_path__ + "static/media/info.0a6edf3b.svg";